import AppContext from "@/contexts/appctx/app-context";
import PoolContext from "@/seed/contexts/pool/pool-context";
import { getDataFromContract } from "@/seed/utils/sale-info";
import { getSeedData } from "@/utils/blockchain";
import Image from "next/image";
import { useContext, useEffect, useState } from "react";

const PurchaseProgressBar = ({ data }) => {
    const { saleEvent } = useContext(PoolContext);
    const appContext = useContext(AppContext);
    console.log("PurchaseProgressBar", { saleEvent });

    if (!saleEvent) return <div>Loading</div>;
    // TODO: confirm UX
    if (!saleEvent?.saleProgress) return <div>Please Connect Your Wallet for more details</div>;

    const { soldAllocation, totalAllocation } = saleEvent.saleProgress;
    console.log("PurchaseProgressBar", { saleEvent, soldAllocation, totalAllocation });
    const currentProgress = Math.round(
        (parseFloat(soldAllocation) / parseFloat(totalAllocation)) * 100
    );

    const [saleProgress, updateProgress] = useState({
        currentProgress,
        soldAllocation,
        totalAllocation,
    });

    const { seedContract } = appContext.blockchain;

    useEffect(() => {
        if (seedContract) {
            seedContract.off("BuySeed");
            seedContract.on("BuySeed", () => {
                console.log("Event_BuySeed");
                syncProgressFromContract();
            });
        }
    }, [seedContract]);

    useEffect(() => {
        return () => {
            if (seedContract) {
                seedContract.off("BuySeed");
            }
        };
    });

    const syncProgressFromContract = async () => {
        const seedData = await getSeedData(seedContract);
        const { currentBalance, hardCap } = getDataFromContract(seedData);
        const currentProgress = (parseFloat(currentBalance) / parseFloat(hardCap)) * 100;

        updateProgress({
            currentProgress: ((currentProgress * 100) | 0) / 100, // round 2 digits
            soldAllocation: currentBalance,
            totalAllocation: hardCap,
        });
    };

    // contract.on

    return (
        <div className="flex flex-col w-screen lg:w-auto lg:max-w-5xl px-[10%]">
            <div className="flex flex-col w-full space-y-3 md:space-y-4 lg:space-y-5">
                <div className="flex flex-col">
                    <div className="flex flex-row z-10">
                        <div
                            className="overflow-hidden"
                            style={{ width: saleProgress.currentProgress + "%" }}
                        >
                            <div className="bg-[url('/img/fire@3x.webp')] bg-left bg-contain bg-repeat-x w-screen h-5 md:h-10 lg:h-14"></div>
                        </div>
                    </div>
                    <div className="relative h-2 md:h-3 z-10">
                        <div className="flex flex-row w-full h-full bg-gray-200 absolute rounded-full"></div>
                        <div
                            className={
                                currentProgress >= 100
                                    ? "h-full bg-[#ff2b2b] absolute rounded-full"
                                    : "h-full bg-[#ff2b2b] absolute rounded-l-lg"
                            }
                            style={{ width: saleProgress.currentProgress + "%" }}
                        >
                            <div className="w-full flex justify-end">
                                <div className="-mr-2 md:-mr-3 -mt-6 md:-mt-8 lg:-mt-10 w-10 md:w-14 lg:w-16">
                                    <Image
                                        src={data.loadingBar.token.img}
                                        width={data.loadingBar.token.width}
                                        height={data.loadingBar.token.height}
                                        layout="intrinsic"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full flex flex-row justify-between items-between text-[9px] md:text-[16px] lg:text-lg text-right">
                    <span className="">{saleProgress.currentProgress} %</span>
                    <div className="flex flex-row space-x-1 md:space-x-3">
                        <span className="">
                            {parseFloat(saleProgress.soldAllocation).toLocaleString("en")}
                        </span>
                        <span className="">/</span>
                        <span className="">
                            {parseFloat(saleProgress.totalAllocation).toLocaleString("en")}
                        </span>
                        <span className="">{saleEvent.acceptedCurrency}</span>
                    </div>
                </div>
            </div>
        </div>
    );
    return null;
};

export default PurchaseProgressBar;
